<template>
  <!-- Row -->
  <div class="detailed-site-screen">
    <div class="panel panel-default border-panel card-view">
      <div>
        <nav-bar :tabs="this.loggedInUser.role === 'admin' || this.loggedInUser.role === 'partner_admin' ? adminTabs : tabs" @tabChanged="tabChanged"/>
      </div>
      <div>
        <component v-bind:is="component" :model="model"/>
      </div>
    </div>
  </div>
  <!-- Row -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NavBar from '@/components/shared/navigations/NavBar';
import PageHeader from '@/components/shared/layouts/PageHeader';
import NoteScreen from '@/components/modules/helpdesk/NoteScreen';
import SiteScreen from './SiteScreen';
import WorkersScreen from './WorkersScreen';
import LocationsScreen from './LocationsScreen';

export default {
  name: 'DetailedSiteScreen',
  components: {
    'nav-bar': NavBar,
    'site-screen': SiteScreen,
    'workers-screen': WorkersScreen,
    'note-screen': NoteScreen,
    'locations-screen': LocationsScreen,
    'page-header': PageHeader,
  },
  data() {
    return {
      currentPageIndex: 1,
      searchTerm: '',
      roles: ['worker', 'vivu'],
      selected: 0,
      tabs: [
        {
          name: this.$t('app.navigation.partner_navbar.basic_details'),
          index: 0,
        },
      ],
      adminTabs: [
        {
          name: this.$t('app.navigation.partner_navbar.basic_details'),
          index: 0,
        },
        {
          name: this.$t('app.navigation.partner_navbar.sites'),
          index: 1,
        },
        {
          name: this.$t('app.navigation.partner_navbar.workers'),
          index: 2,
        },
      ],
    };
  },
  created() {
    this.fetchPartner(this.loggedInUser.partner_id);
    this.fetchLocations({
      siteId: this.$route.params.id,
      pageIndex: this.currentPageIndex,
    });
    this.fetchWorkers({
      partnerId: this.loggedInUser.partner_id,
      siteId: this.$route.params.id,
      pageIndex: this.currentPageIndex,
    });
  },
  computed: {
    ...mapGetters({
      partner: 'partners/selectedPartner',
      users: 'users/allUsers',
      sites: 'sites/allSites',
      locations: 'locations/allLocations',
      commonData: 'partners/commonData',
      loggedInUser: 'loggedInUser',
    }),
    component() {
      if (this.loggedInUser.role === 'admin') {
        switch (this.selected) {
          case 0: {
            return 'site-screen';
          }
          case 1: {
            return 'locations-screen';
          }
          case 2: {
            return 'workers-screen';
          }
          case 3: {
            return 'note-screen';
          }
          default: {
            return 'site-screen';
          }
        }
      } else {
        switch (this.selected) {
          case 0: {
            return 'site-screen';
          }
          case 1: {
            return 'locations-screen';
          }
          case 2: {
            return 'workers-screen';
          }
          default: {
            return 'site-screen';
          }
        }
      }
    },
    model() {
      if (this.loggedInUser.role === 'vivu') {
        switch (this.selected) {
          case 0: {
            return this.detailsModel;
          }
          case 1: {
            return this.locations;
          }
          case 2: {
            return this.users;
          }
          case 3: {
            return [];
          }
          default: {
            return this.detailsModel;
          }
        }
      } else {
        switch (this.selected) {
          case 0: {
            return this.detailsModel;
          }
          case 1: {
            return this.locations;
          }
          case 2: {
            return this.users;
          }
          default: {
            return this.detailsModel;
          }
        }
      }
    },
    detailsModel() {
      const partner = this.partner;
      const fields = ['name', 'identifier', 'email', 'phone', 'industry'];
      const mappedPartner = Object.keys(partner).map((key, _value) => {
        if (fields.includes(key)) {
          return {
            title: key,
            value: partner[key],
          };
        }
      });
      return mappedPartner.filter(el => el != null);
    },
  },
  methods: {
    ...mapActions({
      fetchPartner: 'partners/fetchPartner',
      fetchWorkers: 'users/fetchWorkers',
      fetchLocations: 'locations/fetchLocations',
    }),
    tabChanged(index) {
      this.selected = index;
    },
  },
  watch: {
  },
};
</script>

<style lang="scss" scoped>
.detailed-site-screen {
  /deep/ li {
    cursor: pointer;
  }

  /deep/ li.is-active {
    border-bottom: 2px solid var(--main-color);
  }

  /deep/ li.is-active > a {
    color: var(--main-color);
  }

  .card-view {
    margin-left: 0;
    margin-right: 0;
    padding-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/partners/DetailedSiteScreen.vue